
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_site/[city]/news/[alias]",
      function () {
        return require("private-next-pages/_site/[city]/news/[alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_site/[city]/news/[alias]"])
      });
    }
  